"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionAssignmentSchema = void 0;
const zod_1 = require("zod");
const Signal_1 = require("../DesignModels/Signal");
const FunctionalAddressing_1 = require("./FunctionalAddressing");
const IExternalComponentAssignment_1 = require("./IExternalComponentAssignment");
const IComponentFunctionSignalAssignment_1 = require("./IComponentFunctionSignalAssignment");
const SignalAssignmentsUnionSchema = zod_1.z.union([
    Signal_1.SignalSchema.pick({ id: true }).passthrough().array(),
    IComponentFunctionSignalAssignment_1.IComponentFunctionSignalAssignmentSchema.array(),
]);
function transformSignalAssignments(value) {
    if (value.length === 0) {
        return [];
    }
    const firstElement = value[0];
    if ('componentSignalId' in firstElement) {
        return value;
    }
    return value.map((signal) => ({
        componentSignalId: signal.id,
    }));
}
exports.IComponentFunctionAssignmentSchema = zod_1.z.lazy(() => zod_1.z.object({
    function: zod_1.z.string(),
    functionClass: zod_1.z.string().optional(),
    isUnassigned: zod_1.z.boolean().optional(),
    signalAssignments: zod_1.z.record(zod_1.z.string(), SignalAssignmentsUnionSchema.transform(transformSignalAssignments)),
    externalComponentAssignments: zod_1.z.record(zod_1.z.string(), zod_1.z.record(zod_1.z.string(), zod_1.z.lazy(() => IExternalComponentAssignment_1.IExternalComponentAssignmentSchema).array())),
    addressableComponents: zod_1.z
        .lazy(() => FunctionalAddressing_1.ControllerBusAddressSchema)
        .array()
        .optional(),
    externalConnectionAssignments: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    childBusAssignments: zod_1.z
        .record(zod_1.z.string(), zod_1.z.lazy(() => exports.IComponentFunctionAssignmentSchema))
        .optional(),
}));
//# sourceMappingURL=IComponentFunctionAssignment.js.map